module.exports = __webpack_public_path__ + "img/receipt-example_es.eb40d573.png";